<template>
  <v-container fluid>
    <v-snackbar v-model="showSnackbar" :color="snackbar.color" transition="slide-y-reverse-transition">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          {{getTranslated('_close')}}
        </v-btn>
      </template>
    </v-snackbar>

    <ConfirmationDialog
      :showDialog="showConfirmationDialog"
      :text="getTranslated('_labelWillDeleted')"
      @accept="deleteLabel"
      @cancel="cancelDeleteDialog"
    ></ConfirmationDialog>

    <LabelEditionDialog
      :openDialog="showEditionDialog"
      @input="showEditionDialog = false; clone = false"
      @saved="notify"
      :translations="translations"
      :clone="clone"
    ></LabelEditionDialog>

    <v-skeleton-loader
      :loading="tableLoading"
      type="table"
      class="elevation-1 my-12"
      transition="fade-transition"
    >
      <v-data-table
        :headers="headers"
        :items="lastLabelVersionList"
        width="100%"
        item-key="id"
        multi-sort
        show-expand
        :hide-default-footer="lastLabelVersionList.length <= 10"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTranslated('_labels')}}</v-toolbar-title>
          </v-toolbar>
        </template>

        <template #item.action="{ item }">

          <v-icon
            x-small
            class="mr-1"
            @click="designLabel(item)"
          >
            fa-edit
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="designLabel(item)">{{getTranslated('_design')}}</span>

          <v-icon
            small
            class="mr-1 ml-4"
            @click="editLabel(item)"
          >
            edit
          </v-icon>
          <span class="text-overline" style="cursor: pointer"  @click="editLabel(item)">{{getTranslated('_edit')}}</span>

          <v-icon
            x-small
            class="mr-1 ml-4"
            @click="cloneLabel(item)"
          >
            far fa-clone
          </v-icon>
          <span class="text-overline" style="cursor: pointer"  @click="cloneLabel(item)">{{getTranslated('_clone')}}</span>

          <v-icon
            small
            class="mr-1 ml-4"
            @click="openDeleteDialog(item)"
          >
            delete
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="openDeleteDialog(item)">{{getTranslated('_delete')}}</span>
        </template>

        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <v-btn @click="expand(true)" v-if="!isExpanded && item.labelVersion> 1" icon><v-icon color="#2c3e50">mdi-chevron-down</v-icon></v-btn>
          <v-btn @click="expand(false)" v-if="isExpanded && item.labelVersion> 1" icon><v-icon color="#2c3e50">mdi-chevron-up</v-icon></v-btn>
        </template>

        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length" style="padding: 0px">
            <v-data-table
              :headers="headers"
              :items="filterLabelsById(item.id)"
              item-key="idVersion"
              hide-default-footer
              hide-default-header
              :items-per-page="-1"
            >
              <template #item.action="{ item }">

                <v-icon
                  x-small
                  class="mr-1"
                  @click="designLabel(item)"
                >
                  fa-edit
                </v-icon>
                <span class="text-overline" style="cursor: pointer" @click="designLabel(item)">{{getTranslated('_design')}}</span>

                <v-icon
                  small
                  class="mr-1 ml-4"
                  @click="editLabel(item)"
                >
                  edit
                </v-icon>
                <span class="text-overline" style="cursor: pointer"  @click="editLabel(item)">{{getTranslated('_edit')}}</span>
                <!-- <v-icon
                  small
                  class="mr-1 ml-4"
                  @click="openDeleteDialog(item)"
                >
                  delete
                </v-icon>
                <span class="text-overline" style="cursor: pointer" @click="openDeleteDialog(item)">{{getTranslated('_delete')}}</span> -->
              </template>

              <template #item.description="{ item }">
                {{item.description}}
              </template>

              <template #no-data>
                <label>{{getTranslated('_labelNoData')}}</label>
              </template>
            </v-data-table>
          </td>
        </template>

        <template #no-data>
          <label>{{getTranslated('_labelNoData')}}</label>
        </template>
      </v-data-table>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { actions } from '../store/types/labelTypes.js'
import labelsService from '../services/LabelsService.js'
import screenService from '../services/ScreenService.js'
import translationsService from '../services/TranslationsService'
const LabelEditionDialog = () =>
  import('../components/LabelEditionDialog.vue')
const ConfirmationDialog = () =>
  import('../components/ConfirmationDialog.vue')

export default {
  components: {
    LabelEditionDialog,
    ConfirmationDialog
  },
  data () {
    return {
      tableLoading: true,
      showSnackbar: false,
      snackbar: {
        color: '',
        message: ''
      },
      showConfirmationDialog: false,
      showEditionDialog: false,
      labelToDelete: '',
      permits: '',
      clone: false,
      lastLabelVersionList: [],
      translations: [
        { key: '_labelWillDeleted', translation: 'Label will be deleted' },
        { key: '_labelNoData', translation: 'No labels were found' },
        { key: '_close', translation: 'Close' },
        { key: '_labelDeleted', translation: 'Label deleted' },
        { key: '_labelDeletedError', translation: 'Error deleting label' },
        { key: '_labels', translation: 'Labels' },
        { key: '_edit', translation: 'Edit' },
        { key: '_delete', translation: 'Delete' },
        { key: '_editLabel', translation: 'Edit Label' },
        { key: '_name', translation: 'Name' },
        { key: '_save', translation: 'Save' },
        { key: '_cancel', translation: 'Cancel' },
        { key: '_required', translation: 'Required' },
        { key: '_description', translation: 'Description' },
        { key: '_labelVersions', translation: 'Label Versions' },
        { key: '_design', translation: 'Design' },
        { key: '_value', translation: 'Value' },
        { key: '_clone', translation: 'Clone' },
        { key: '_saveRequiredValuesAlert', translation: 'To save enter the required values' }
      ]
    }
  },
  computed: mapState({
    headers: state => state.labels.headers,
    labelList: state => state.labels.labelList
  }),
  methods: {
    ...mapActions({
      saveCurrentLabel: actions.SAVE_CURRENT_LABEL,
      getHeaders: actions.GET_HEADERS,
      getLabels: actions.GET_LABELS,
      savePagination: actions.SAVE_PAGINATION
    }),
    editLabel (item) {
      this.saveCurrentLabel(item)
      this.showEditionDialog = true
    },
    cloneLabel (item) {
      this.saveCurrentLabel(item)
      this.clone = true
      this.showEditionDialog = true
    },
    openDeleteDialog (item) {
      this.showConfirmationDialog = true
      this.labelToDelete = item
    },
    async deleteLabel (item) {
      await labelsService.deleteLabel(this.labelToDelete.id, this.labelToDelete.labelVersion).then(res => {
        this.cancelDeleteDialog()
        this.getLabels()
        this.snackbar.color = res.request.status === 200 ? 'green' : 'red'
        this.snackbar.message = res.request.status === 200 ? this.getTranslated('_labelDeleted') : this.getTranslated('_labelDeletedError')
        this.showSnackbar = true
        this.loadLabels()
      }).catch((e) => this.errorManagement(e))
    },
    cancelDeleteDialog () {
      this.showConfirmationDialog = false
      this.labelToDelete = ''
    },
    notify (notification) {
      this.loadLabels()
      this.snackbar.color = notification.color
      this.snackbar.message = notification.message
      this.showSnackbar = true
      this.clone = false
    },
    async loadLabels () {
      await this.getLabels().catch((e) => this.errorManagement(e))
      this.groupLabelById()
      this.labelList.forEach(element => {
        element.idVersion = element.id + '-' + element.labelVersion
      })
    },
    async initialize () {
      if (this.$root.$data.user.profile !== undefined) {
        this.permits = await screenService.getScreenPermits('Labeling_Labels', this.$root.$data.user.profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']).catch((e) => this.errorManagement(e))
        this.permits = this.permits.data
        await this.getTranslations().catch((e) => this.errorManagement(e))
        await this.getHeaders('Labeling_Labels').catch((e) => this.errorManagement(e))
        this.headers.forEach(element => {
          // Reducimos el tamaño del campo descripción
          if (element.value === 'description') {
            element.width = '50%'
          }
          // Especificamos el tamaño del campo action
          if (element.value === 'action') {
            element.width = '420px'
          }
        })
      }
    },
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get('Labeling_Labels', this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    filterLabelsById (labelId) {
      var labelIdList = []
      this.labelList.forEach(element => {
        if (element.id === labelId) {
          labelIdList.push(element)
        }
      })
      return labelIdList
    },
    groupLabelById () {
      this.lastLabelVersionList = []
      var copiedList = JSON.parse(JSON.stringify(this.labelList))
      var sortedList = copiedList.sort((a, b) => b.labelVersion - a.labelVersion)
      sortedList.forEach(element => {
        if (!this.lastLabelVersionList.find(x => x.id === element.id)) {
          this.lastLabelVersionList.push(element)
        }
      })
    },
    designLabel (item) {
      this.$router.push('LabelDesigner/' + item.id + '/' + item.labelVersion)
    },
    errorManagement (e) {
      if (e.response !== undefined) {
        switch (e.response.status) {
          case 401:
            this.notify({ color: 'warning', message: 'Unauthorized error' })
            break
          case 422:
            this.notify({ color: 'warning', message: 'Unprocessable Entity error' })
            break
          case 500:
            this.notify({ color: 'warning', message: 'Internal server error' })
            break
          default:
            this.notify({ color: 'warning', message: 'Unexpected error' })
            break
        }
      } else {
        this.notify({ color: 'warning', message: 'Unexpected error' })
      }
    }
  },
  async created () {
    await this.initialize()
    await this.loadLabels()
    this.tableLoading = false
  },
  beforeMount () {
    this.$store.state.labels.headers = Object.assign([])
  }
}
</script>
